export default "__VITE_ASSET__57226179__"